import { Outlet, RouteObject } from "react-router";
import { lazy, Suspense } from "react";
import { SuspenseLoading } from "@/common/components/SuspenseLoading.tsx";
import { OvertimeRequestDetailsProvider } from '@/pages/overtime/overtime-details/useOvertimeRequestDetails.ts'

const OvertimeListPage = lazy(() => import('@/pages/overtime/overtime-list/overtime-list-page.tsx'))
const OvertimeDetailsPage = lazy(() => import('@/pages/overtime/overtime-details/overtime-details-page.tsx'))

export const overtimeRoutes: RouteObject = {
  path: 'overtime',
  element: <Outlet />,
  children: [
    {
      index: true,
      element: <Suspense fallback={<SuspenseLoading />}>
        <OvertimeListPage />
      </Suspense>,
    },
    {
      path: ':overtimeId',
      element: <Suspense fallback={<SuspenseLoading />}>
        <OvertimeRequestDetailsProvider>
          <OvertimeDetailsPage />
        </OvertimeRequestDetailsProvider>
      </Suspense>,
    },
  ]
}